import { matchPath } from "react-router";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import LocalStorageService from "@ane/core/lib/services/LocalStorageService";
import { LAST_WORKSPACE_ID, LAST_EXPERIMENTATION_GROUP } from "../constants/StudioLocalStorage.constants.js";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
import { ROUTES } from "../routes/Routes.constants.js";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import Logger from "@ane/core/lib/services/logging/Logger";
import { UserAffinityTelemetryEventNames } from "./UserAffinityTelemetryEventNames.js";
const getStudioWorkspaceIdFromPathname = (pathname = window.location.pathname) => {
  var _a, _b;
  const match = matchPath(pathname, { path: ROUTES.studio.match.path });
  const workspaceId = ((_b = (_a = match == null ? void 0 : match.params) == null ? void 0 : _a.workspaceId) == null ? void 0 : _b.toLowerCase()) || "";
  return workspaceId;
};
const getWorkspaceIdFromLocalStorage = () => {
  let lastWorkspaceId = "";
  const isRoot = !!matchPath(WindowLocation.pathname, {
    path: "/",
    exact: true
  });
  const isWorkspaceRoot = !!matchPath(WindowLocation.pathname, {
    path: ROUTES.studio.location.pathname,
    exact: true
  });
  if (isRoot || isWorkspaceRoot) {
    lastWorkspaceId = getLastWorkspaceId();
  }
  return lastWorkspaceId;
};
const getStudioWorkspaceId = () => {
  const workspaceId = getStudioWorkspaceIdFromPathname();
  const lastWorkspaceId = getWorkspaceIdFromLocalStorage();
  return workspaceId || lastWorkspaceId;
};
const getCTWorkspaceId = () => {
  const workspaceId = EnvironmentService.getQueryParam(WORKSPACE_ID);
  return !!workspaceId ? workspaceId == null ? void 0 : workspaceId.toLowerCase() : workspaceId;
};
const getDefaultWorkspaceId = () => {
  const workspaceId = getStudioWorkspaceIdFromPathname() || getCTWorkspaceId() || getStudioWorkspaceId();
  Logger.trackEvent({
    name: UserAffinityTelemetryEventNames.App_UserAffinity_getDefaultWorkspaceId,
    properties: { workspaceId },
    measurements: {}
  });
  setLastWorkspaceId(workspaceId);
  return workspaceId;
};
const setUserAffinity = (workspaceId, experimentationGroup) => {
  Logger.trackEvent({
    name: UserAffinityTelemetryEventNames.App_UserAffinity_setUserAffinity,
    properties: { workspaceId, experimentationGroup },
    measurements: {}
  });
  LocalStorageService.setItem(LAST_WORKSPACE_ID, workspaceId);
  LocalStorageService.setItem(LAST_EXPERIMENTATION_GROUP, experimentationGroup);
};
const clearUserAffinity = () => {
  Logger.trackEvent({
    name: UserAffinityTelemetryEventNames.App_UserAffinity_clearUserAffinity,
    properties: { lastWorkspaceId: getLastWorkspaceId(), lastExperimentationGroup: getLastExperimentationGroupId() },
    measurements: {}
  });
  LocalStorageService.removeItem(LAST_WORKSPACE_ID);
  LocalStorageService.removeItem(LAST_EXPERIMENTATION_GROUP);
};
const setLastWorkspaceId = (workspaceId) => {
  if (!!workspaceId && !getLastWorkspaceId()) {
    Logger.trackEvent({
      name: UserAffinityTelemetryEventNames.App_UserAffinity_setlastWorkspaceId,
      properties: {
        workspaceId,
        lastWorkspaceId: getLastWorkspaceId(),
        lastExperimentationGroup: getLastExperimentationGroupId()
      },
      measurements: {}
    });
    LocalStorageService.setItem(LAST_WORKSPACE_ID, workspaceId);
    LocalStorageService.removeItem(LAST_EXPERIMENTATION_GROUP);
  }
};
const setLastExperimentationGroup = (experimentationGroup = "") => {
  Logger.trackEvent({
    name: UserAffinityTelemetryEventNames.App_UserAffinity_setLastExperimentationGroup,
    properties: {
      experimentationGroup,
      lastExperimentationGroup: getLastExperimentationGroupId()
    },
    measurements: {}
  });
  LocalStorageService.setItem(LAST_EXPERIMENTATION_GROUP, experimentationGroup);
};
const getLastWorkspaceId = () => {
  var _a, _b;
  return (_b = (_a = LocalStorageService.getItem(LAST_WORKSPACE_ID)) == null ? void 0 : _a.toLowerCase()) != null ? _b : "";
};
const getLastExperimentationGroupId = () => {
  var _a;
  return (_a = LocalStorageService.getItem(LAST_EXPERIMENTATION_GROUP)) != null ? _a : "";
};
export {
  clearUserAffinity,
  getCTWorkspaceId,
  getDefaultWorkspaceId,
  getLastExperimentationGroupId,
  getLastWorkspaceId,
  getStudioWorkspaceId,
  getStudioWorkspaceIdFromPathname,
  getWorkspaceIdFromLocalStorage,
  setLastExperimentationGroup,
  setLastWorkspaceId,
  setUserAffinity
};
//# sourceMappingURL=GetUserAffinity.utils.js.map
